import React, {useState} from 'react';
import './Chooser.component.scss'
import TaxiForm from "./TaxiForm";
import {Element} from "react-scroll"
export enum Mode {
    One,
    Round,
    Multi
}

export default function Chooser() {
    const [mode, setMode] = useState<Mode>(Mode.Multi)
    const [count, setCount] = useState<number>(3)
    const handleRemove = () => {
        setCount(count > 1 ? count - 1 : count)
    }
    const handleAdd = () => {
        setCount(count + 1)
    }
    return (
        <Element name={"chooser"}>
        <div className={"chooser"}>
            <div className="container">

                <div className="modes">
                    <span className={mode === Mode.One ? "active" : ""} onClick={() => setMode(Mode.One)}>One-way</span>
                    <span className={mode === Mode.Round ? "active" : ""} onClick={() => setMode(Mode.Round)}>Round-trip</span>
                    <span className={mode === Mode.Multi ? "active" : ""} onClick={() => setMode(Mode.Multi)}>Multi-leg</span>
                </div>
                {
                    mode === Mode.One && <TaxiForm showSearchBar={true} />
                }
                {
                    mode === Mode.Round &&
                    <>
                        <div>
                            <h3 style={{color: "white"}}>Outround</h3>
                            <TaxiForm showSearchBar={false} />
                        </div>
                        <div>
                            <h3 style={{color: "white"}}>Inround</h3>
                            <TaxiForm showSearchBar={false}></TaxiForm>
                        </div>
                        <button type="button" className={"search_button"}>search</button>
                    </>
                }
                {
                    mode === Mode.Multi &&
                    <>
                        {[...Array(count).keys()].map(x => (
                            <div>
                                <h3 style={{color: "white"}}>Leg {x+1}</h3>
                                <TaxiForm showSearchBar={count === 1} />
                            </div>
                        ))}
                        <div className={"add-remove"}>
                            <span onClick={() => handleAdd()}>+Add</span>
                            {"  "}
                            <span onClick={() => handleRemove()}>-Remove</span>
                        </div>
                        {
                            count > 1 && <button type="button" className={"search_button"}>search</button>
                        }
                    </>
                }
            </div>

        </div>
    </Element>
    )
}